var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    fill: "#F5F8FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8333 19.7857V21.9286H10.1667V19.7857H9V21.9286C9 22.2127 9.12292 22.4853 9.34171 22.6862C9.5605 22.8871 9.85725 23 10.1667 23H21.8333C22.1428 23 22.4395 22.8871 22.6583 22.6862C22.8771 22.4853 23 22.2127 23 21.9286V19.7857H21.8333ZM21.8333 14.4286L21.0108 13.6732L16.5833 17.7339V8H15.4167V17.7339L10.9892 13.6732L10.1667 14.4286L16 19.7857L21.8333 14.4286Z",
    fill: "#8898A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDownload);
export default __webpack_public_path__ + "static/media/ic-download.b707b014387f81838ec2856dd847d78e.svg";
export { ForwardRef as ReactComponent };